import { Config } from "../../../../Config";
import { RenderClearFlag } from "../../../RenderEngine/RenderEnum/RenderClearFlag";
import { Shader3D } from "../../../RenderEngine/RenderShader/Shader3D";
import { LayaGL } from "../../../layagl/LayaGL";
import { StatElement } from "../../../layagl/StatisticsContext";
import { Color } from "../../../maths/Color";
import { WebDefineDatas } from "../../RenderModuleData/WebModuleData/WebDefineDatas";
import { WebGLEngine } from "../RenderDevice/WebGLEngine";
export class WebGLRenderContext3D {
    get sceneData() {
        return this._sceneData;
    }
    set sceneData(value) {
        this._sceneData = value;
        if (Config._uniformBlock && this.sceneData) {
            for (let key of this._preDrawUniformMaps) {
                let uniformMap = LayaGL.renderDeviceFactory.createGlobalUniformMap(key);
                if (uniformMap._idata.size > 0) {
                    this.sceneData.createUniformBuffer(key, uniformMap._idata);
                }
            }
        }
    }
    get cameraData() {
        return this._cameraData;
    }
    set cameraData(value) {
        this._cameraData = value;
        if (Config._uniformBlock && this.cameraData) {
            let cameraMap = LayaGL.renderDeviceFactory.createGlobalUniformMap("BaseCamera");
            this.cameraData.createUniformBuffer("BaseCamera", cameraMap._idata);
        }
    }
    get sceneModuleData() {
        return this._sceneModuleData;
    }
    set sceneModuleData(value) {
        this._sceneModuleData = value;
    }
    get cameraModuleData() {
        return this._cameraModuleData;
    }
    set cameraModuleData(value) {
        this._cameraModuleData = value;
    }
    get globalShaderData() {
        return this._globalShaderData;
    }
    set globalShaderData(value) {
        this._globalShaderData = value;
    }
    _getContextShaderDefines() {
        return this._cacheGlobalDefines;
    }
    _prepareContext() {
        let contextDef = this._cacheGlobalDefines;
        if (this.sceneData) {
            this.sceneData._defineDatas.cloneTo(contextDef);
            for (let key of this._preDrawUniformMaps) {
                this.sceneData.updateUBOBuffer(key);
            }
        }
        else {
            this._globalConfigShaderData.cloneTo(contextDef);
        }
        if (this.cameraData) {
            contextDef.addDefineDatas(this.cameraData._defineDatas);
            this.cameraData.updateUBOBuffer("BaseCamera");
        }
    }
    setRenderTarget(value, clearFlag) {
        this._clearFlag = clearFlag;
        if (value == this._renderTarget)
            return;
        this._renderTarget = value;
        this._needStart = true;
    }
    setViewPort(value) {
        this._viewPort = value;
        this._needStart = true;
    }
    setScissor(value) {
        this._scissor = value;
        this._needStart = true;
    }
    get sceneUpdataMask() {
        return this._sceneUpdataMask;
    }
    set sceneUpdataMask(value) {
        this._sceneUpdataMask = value;
    }
    get cameraUpdateMask() {
        return this._cameraUpdateMask;
    }
    set cameraUpdateMask(value) {
        this._cameraUpdateMask = value;
    }
    get pipelineMode() {
        return this._pipelineMode;
    }
    set pipelineMode(value) {
        this._pipelineMode = value;
    }
    get invertY() {
        return this._invertY;
    }
    set invertY(value) {
        this._invertY = value;
    }
    constructor() {
        this._cacheGlobalDefines = new WebDefineDatas();
        this._needStart = true;
        this._clearColor = new Color();
        this._globalConfigShaderData = Shader3D._configDefineValues;
        this._preDrawUniformMaps = new Set();
        this.cameraUpdateMask = 0;
        WebGLRenderContext3D._instance = this;
    }
    runOneCMD(cmd) {
        cmd.apply(this);
    }
    runCMDList(cmds) {
        cmds.forEach(element => {
            element.apply(this);
        });
    }
    setClearData(clearFlag, color, depth, stencil) {
        this._clearFlag = clearFlag;
        color.cloneTo(this._clearColor);
        this._clearDepth = depth;
        this._clearStencil = stencil;
        return 0;
    }
    drawRenderElementList(list) {
        if (this._needStart) {
            this._bindRenderTarget();
            this._start();
            this._needStart = false;
        }
        this._prepareContext();
        let elements = list.elements;
        for (var i = 0, n = list.length; i < n; i++) {
            elements[i]._preUpdatePre(this);
        }
        let bufferMgr = WebGLEngine.instance.bufferMgr;
        if (bufferMgr) {
            bufferMgr.upload();
        }
        for (var i = 0, n = list.length; i < n; i++) {
            elements[i]._render(this);
        }
        LayaGL.statAgent.recordCTData(StatElement.CT_3DDrawCall, list.length);
        LayaGL.renderEngine._framePassCount++;
        return 0;
    }
    drawRenderElementOne(node) {
        if (this._needStart) {
            this._bindRenderTarget();
            this._start();
            this._needStart = false;
        }
        this._prepareContext();
        node._preUpdatePre(this);
        let bufferMgr = WebGLEngine.instance.bufferMgr;
        if (bufferMgr) {
            bufferMgr.upload();
        }
        node._render(this);
        LayaGL.statAgent.recordCTData(StatElement.CT_3DDrawCall, 1);
        LayaGL.renderEngine._framePassCount++;
        return 0;
    }
    _bindRenderTarget() {
        if (this._renderTarget) {
            LayaGL.textureContext.bindRenderTarget(this._renderTarget);
        }
        else {
            LayaGL.textureContext.bindoutScreenTarget();
        }
    }
    _start() {
        WebGLEngine.instance.scissorTest(true);
        WebGLEngine.instance.viewport(this._viewPort.x, this._viewPort.y, this._viewPort.width, this._viewPort.height);
        WebGLEngine.instance.scissor(this._viewPort.x, this._viewPort.y, this._viewPort.width, this._viewPort.height);
        if (this._clearFlag != RenderClearFlag.Nothing)
            WebGLEngine.instance.clearRenderTexture(this._clearFlag, this._clearColor, this._clearDepth, this._clearStencil);
        WebGLEngine.instance.scissor(this._scissor.x, this._scissor.y, this._scissor.z, this._scissor.w);
    }
}
